export default __webpack_public_path__ + "static/media/cli-alph-reso_inconfidentes.fe7a35a0.jpg";